import type { OrderStatus } from "../drizzle/schema";

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  pending_payment: "결제 대기",
  paid: "결제완료",
  image_review: "이미지 검수중",
  in_production: "제작중",
  ready_to_ship: "배송 준비",
  shipping: "배송중",
  delivered: "배송완료",
  cancelled: "주문 취소",
};

/** Linear progression shown in the customer status timeline. */
export const ORDER_STATUS_FLOW: OrderStatus[] = [
  "paid",
  "image_review",
  "in_production",
  "ready_to_ship",
  "shipping",
  "delivered",
];

export const ORDER_STATUSES_FOR_ADMIN: OrderStatus[] = [
  "pending_payment",
  "paid",
  "image_review",
  "in_production",
  "ready_to_ship",
  "shipping",
  "delivered",
  "cancelled",
];
